// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-register-container {
    padding: 0 40px 40px;
    background-color: #fff;
}

.customer-register-container .breadcrumb {
    background-color: #f5f5f5;
    padding: 21px 82px;
    margin: 0 -40px 30px;
    color: #717171;
}

.page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 30px;
}

.page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}

.page-header h2 {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
}

.form-section {
    margin-bottom: 40px;
}

.section-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #222;
    padding-bottom: 15px;
    margin-bottom: 0;
}

.section-title-container h3 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
}

.btn-sm {
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    font-size: 14px;
}

.btn-dark {
    background-color: #222;
    color: white;
}

.form-table {
    margin-top: 0;
}

.form-row {
    display: flex;
    border-bottom: 1px solid #eee;
    align-items: center;
}

.form-label {
    background-color: #f9f9f9;
    font-weight: bold;
    padding: 20px 30px;
    width: 150px;
    min-width: 150px;
    display: flex;
    align-items: center;
}

.form-row.multi-field-row .form-label {
    align-self: stretch;
}

.form-row .required {
    color: #e84118;
    margin-left: 5px;
}

.form-input-container {
    padding: 15px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-grow: 1;
    flex-wrap: wrap;
}

.form-input-container input[type="text"],
.form-input-container input[type="email"],
.form-input-container input[type="password"],
.form-input-container select,
.form-input-container textarea {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 15px;
    flex-grow: 1;
}

.form-input-container .short-input {
    flex-grow: 0;
    width: 250px;
}
.form-input-container .long-input {
    flex-grow: 0;
    width: 432px;
}
.form-input-container .short-select {
    flex-grow: 0;
    width: 287px;
}

.form-input-container select {
    width: auto;
    min-width: 200px;
}

.form-input-container textarea {
    height: 120px;
    width: 960px;
}

.biz-num-inputs {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 10px;
}

.biz-num-inputs input {
    width: 80px !important;
    text-align: center;
    flex-grow: 0;
}
.multi-field-row .form-input-container {
    justify-content: space-between;
}
.form-sub-field {
    display: flex;
    align-items: center;
    gap: 10px;
}
.form-sub-field .form-label {
    background-color: transparent;
    width: auto;
    padding: 0 15px 0 0;
}


.input-hint {
    margin: 0;
    color: #666;
    font-size: 14px;
    width: 100%;
    flex-basis: 100%;
}
.full-width {
    padding-top: 10px;
}

.long-hint {
    white-space: normal;
    width: auto;
    line-height: 1.5;
    color: #222;
    font-size: 13px;
    align-self: center;
    padding: 0 20px;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 5px;
}

.page-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 50px;
    border-top: 1px solid #222;
    padding-top: 40px;
}

.page-actions button {
    width: 350px;
    padding: 15px;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-secondary {
    background-color: #222;
    color: white;
    border: none;
}

.btn-primary {
    background-color: #e84118;
    color: white;
    border: none;
}
.form-row.memo-row {
    align-items: stretch;
}
.form-row.memo-row .form-label {
    padding-top: 15px;
    align-items: flex-start;
}

.arrow-icon {
    font-size: 16px;
    font-weight: bold;
}

/* 에러 메시지 스타일 */
.error-message {
    color: #e74c3c;
    font-size: 12px;
    margin-top: 4px;
    margin-left: 2px;
    line-height: 1.4;
}

/* 폼 필드 에러 상태 */
.form-input-container input.error,
.form-input-container select.error {
    border-color: #e74c3c;
    background-color: #fdf2f2;
}

/* 버튼 비활성화 상태 */
.btn-primary:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
    opacity: 0.7;
}

.btn-sm:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
    opacity: 0.7;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .form-label {
        width: 120px;
        min-width: 120px;
        padding: 15px;
    }

    .form-input-container textarea {
        width: 100%;
    }

    .page-actions button {
        width: 250px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .customer-register-container {
        padding: 0 20px 20px;
    }
    
    .form-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
        padding: 15px 0;
    }
    
    .form-label {
        width: 100%;
        background: none;
        padding: 0 0 5px 0;
    }
    
    .form-input-container {
        width: 100%;
        padding: 0;
    }

    .form-input-container input[type="text"],
    .form-input-container input[type="email"],
    .form-input-container input[type="password"],
    .form-input-container select,
    .form-input-container textarea,
    .form-input-container .short-input,
    .form-input-container .long-input,
    .form-input-container .short-select {
        width: 100%;
    }
    
    .biz-num-inputs {
        width: 100%;
    }
    .biz-num-inputs input {
        width: 30% !important;
    }

    .multi-field-row .form-input-container,
    .form-sub-field {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .page-actions {
        flex-direction: column;
    }
    
    .page-actions button {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/CustomerRegisterPage.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;;;;;IAKI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;;IAEI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;;;;;;;;QAQI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;IACA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".customer-register-container {\n    padding: 0 40px 40px;\n    background-color: #fff;\n}\n\n.customer-register-container .breadcrumb {\n    background-color: #f5f5f5;\n    padding: 21px 82px;\n    margin: 0 -40px 30px;\n    color: #717171;\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 30px;\n}\n\n.page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n\n.page-header h2 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n}\n\n.form-section {\n    margin-bottom: 40px;\n}\n\n.section-title-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 2px solid #222;\n    padding-bottom: 15px;\n    margin-bottom: 0;\n}\n\n.section-title-container h3 {\n    font-size: 20px;\n    font-weight: bold;\n    margin: 0;\n}\n\n.btn-sm {\n    padding: 10px 20px;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.btn-dark {\n    background-color: #222;\n    color: white;\n}\n\n.form-table {\n    margin-top: 0;\n}\n\n.form-row {\n    display: flex;\n    border-bottom: 1px solid #eee;\n    align-items: center;\n}\n\n.form-label {\n    background-color: #f9f9f9;\n    font-weight: bold;\n    padding: 20px 30px;\n    width: 150px;\n    min-width: 150px;\n    display: flex;\n    align-items: center;\n}\n\n.form-row.multi-field-row .form-label {\n    align-self: stretch;\n}\n\n.form-row .required {\n    color: #e84118;\n    margin-left: 5px;\n}\n\n.form-input-container {\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-grow: 1;\n    flex-wrap: wrap;\n}\n\n.form-input-container input[type=\"text\"],\n.form-input-container input[type=\"email\"],\n.form-input-container input[type=\"password\"],\n.form-input-container select,\n.form-input-container textarea {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 15px;\n    flex-grow: 1;\n}\n\n.form-input-container .short-input {\n    flex-grow: 0;\n    width: 250px;\n}\n.form-input-container .long-input {\n    flex-grow: 0;\n    width: 432px;\n}\n.form-input-container .short-select {\n    flex-grow: 0;\n    width: 287px;\n}\n\n.form-input-container select {\n    width: auto;\n    min-width: 200px;\n}\n\n.form-input-container textarea {\n    height: 120px;\n    width: 960px;\n}\n\n.biz-num-inputs {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    gap: 10px;\n}\n\n.biz-num-inputs input {\n    width: 80px !important;\n    text-align: center;\n    flex-grow: 0;\n}\n.multi-field-row .form-input-container {\n    justify-content: space-between;\n}\n.form-sub-field {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.form-sub-field .form-label {\n    background-color: transparent;\n    width: auto;\n    padding: 0 15px 0 0;\n}\n\n\n.input-hint {\n    margin: 0;\n    color: #666;\n    font-size: 14px;\n    width: 100%;\n    flex-basis: 100%;\n}\n.full-width {\n    padding-top: 10px;\n}\n\n.long-hint {\n    white-space: normal;\n    width: auto;\n    line-height: 1.5;\n    color: #222;\n    font-size: 13px;\n    align-self: center;\n    padding: 0 20px;\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.page-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 50px;\n    border-top: 1px solid #222;\n    padding-top: 40px;\n}\n\n.page-actions button {\n    width: 350px;\n    padding: 15px;\n    border-radius: 5px;\n    font-size: 18px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.btn-secondary {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-primary {\n    background-color: #e84118;\n    color: white;\n    border: none;\n}\n.form-row.memo-row {\n    align-items: stretch;\n}\n.form-row.memo-row .form-label {\n    padding-top: 15px;\n    align-items: flex-start;\n}\n\n.arrow-icon {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n/* 에러 메시지 스타일 */\n.error-message {\n    color: #e74c3c;\n    font-size: 12px;\n    margin-top: 4px;\n    margin-left: 2px;\n    line-height: 1.4;\n}\n\n/* 폼 필드 에러 상태 */\n.form-input-container input.error,\n.form-input-container select.error {\n    border-color: #e74c3c;\n    background-color: #fdf2f2;\n}\n\n/* 버튼 비활성화 상태 */\n.btn-primary:disabled {\n    background-color: #bdc3c7;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n.btn-sm:disabled {\n    background-color: #bdc3c7;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .form-label {\n        width: 120px;\n        min-width: 120px;\n        padding: 15px;\n    }\n\n    .form-input-container textarea {\n        width: 100%;\n    }\n\n    .page-actions button {\n        width: 250px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .customer-register-container {\n        padding: 0 20px 20px;\n    }\n    \n    .form-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n        padding: 15px 0;\n    }\n    \n    .form-label {\n        width: 100%;\n        background: none;\n        padding: 0 0 5px 0;\n    }\n    \n    .form-input-container {\n        width: 100%;\n        padding: 0;\n    }\n\n    .form-input-container input[type=\"text\"],\n    .form-input-container input[type=\"email\"],\n    .form-input-container input[type=\"password\"],\n    .form-input-container select,\n    .form-input-container textarea,\n    .form-input-container .short-input,\n    .form-input-container .long-input,\n    .form-input-container .short-select {\n        width: 100%;\n    }\n    \n    .biz-num-inputs {\n        width: 100%;\n    }\n    .biz-num-inputs input {\n        width: 30% !important;\n    }\n\n    .multi-field-row .form-input-container,\n    .form-sub-field {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .page-actions {\n        flex-direction: column;\n    }\n    \n    .page-actions button {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
